import { Controller } from "@hotwired/stimulus"
import Pikaday from 'pikaday';

// Connects to data-controller="pikaday-init"
export default class extends Controller {

  static values = {
    mindate: String,
  }

  connect() {
    this.element.autocomplete = 'off';
    let mindate = null;
    if (this.mindateValue.trim() !== '') {
      const [day, month, year] = this.mindateValue.split('/');
      mindate = new Date(`${year}-${month}-${day}`);
    } else {
      mindate = new Date();
    }
    const picker = new Pikaday({
      field: this.element,
      format: 'DD/MM/YYYY',
      minDate: mindate,
      maxDate: new Date(2100, 1, 1),
      firstDay: 1
    });
  }
}
